export const BasicSettingsPluginSettings: IPluginSettings = {
    name: 'Основные настройки',
    mnemocode: 'basic_settings_plugin',
    columns: []
  }